import { usePortalPresenceHeartbeat } from '../../hooks/usePortalPresenceHeartbeat';
import type { PortalPresencePortal } from '../../lib/portalPresence';

type PortalPresenceReporterProps = {
  portal: PortalPresencePortal;
};

/** Invisible heartbeat sender — keeps Settings "who is online" up to date. */
export function PortalPresenceReporter({ portal }: PortalPresenceReporterProps) {
  usePortalPresenceHeartbeat(portal);
  return null;
}
